import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function Categories() {
  const [categories, setCategories] = useState([]);
  useEffect(() => { api.get("/categories").then((r) => setCategories(r.data)); }, []);
  return (
    <div className="container-luxe py-16">
      <div className="mb-12">
        <div className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-3">Explore</div>
        <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight">Categories</h1>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {categories.map((c) => (
          <Link data-testid={`category-card-${c.slug}`} key={c.id} to={`/shop?category=${c.slug}`} className="glass rounded-2xl p-10 hover:border-[#D4AF37]/40 transition-all group">
            <div className="text-xs tracking-widest uppercase text-gray-500">Collection</div>
            <div className="font-display text-2xl mt-3 group-hover:text-[#D4AF37] transition">{c.name}</div>
            <p className="text-gray-400 text-sm mt-4">{c.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
